<template>
  <view class="ad-container" id="ad-container" wx:show="{{isShowAd}}">
    <ad-item wx:show="{{config1}}" config="{{config1}}" index="0"/>
    <view class="line"></view>
    <ad-item wx:show="{{config2}}" config="{{config2}}" index="1"/>
  </view>
</template>

<style lang="stylus" scoped>
  .ad-container
    display flex
    flex-direction row
    border-radius 16px
    background #FFFFFF
    margin-top 8.5px
    align-items center
    .line
      width 1px
      height 49px
      background #F3F4F5
</style>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { trackEvent } from '@/common/track'
  import { Observer } from '@/common/observer'
  import { is } from "@didi/spring-base"
  import { isDdPassengerH5 } from '@/common/constant'
  createComponent({
    props: {
      config: {
        type: Array,
        value: () => []
      }
    },
    data: {
    },
    computed: {
      config1() {
        return this.config?.[0]
      },
      config2() {
        return this.config?.[1]
      },
      isShowAd() {
        const { appid } = this.$mpxRoute.query || {}
        return !is('harmonyos') && !['121735', '2021004166617541'].includes(appid)
      }
    },
    methods: {},
    mounted() {
      this.observer = new Observer({
        element: 'ad-container',
        key: 'userteam_train_home_secbanner_sw',
        name: 'T-火车票-首页-副banner-曝光',
        params: { to_url: [this.config1?.url, this.config2?.url] },
        rootMargin: '-92px 0px'
      })
      this.observer.openObserver()
    },
    watch: {}
  })
</script>

<script  name="json">
  module.exports = {
    usingComponents: {
      'ad-item': './ad-item'
    }
  }
</script>
